import * as React from 'react'

import { TextWidth, TextWidthExtended } from '@ta-interaktiv/react-disco-grid'

import KugelHochSVG from '../../assets/kugel-hohe-lagen'

import styled from 'styled-components'
import kugelDeckelSVG from '../../assets/kugel-deckel.svg'
import SnowAnimator from 'components/Snow/SnowAnimator'
import './styles.scss'

const SnowAnimationContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  /* background-color: green; */
  mask-image: url(${({ maskImage }) => maskImage});
  mask-repeat: no-repeat;
  mask-size: contain;
`
const SnowAnimation = styled.div``

export default class HoheLagen extends React.Component {
  render() {
    return (
      <TextWidth>
        <div className='content' style={{ textAlign: 'center' }}>
          <div className='ui text container category first'>
            <div className='content-wrapper'>
              <div className='category content hoch'>
                <span className='category title hoch'>
                  {this.props.languageContent.hoheLagen.title}
                </span>
                <span className='category hoehe hoch'>
                  {this.props.languageContent.hoheLagen.altitude}
                </span>
              </div>

              <div className='coverContent' id='coverDetail'>
                <div className='coverTextWrapper hoch'>
                <div className='coverProzent hoch'>{this.props.languageContent.hoheLagen.percent}</div>
                  <div className='coverText hoch'>{this.props.languageContent.hoheLagen.unit}</div>
                  <div className='triangle hoch'></div>
                </div>
                <div className='animation-container'>
                  <SnowAnimationContainer
                    maskImage={kugelDeckelSVG}
                    className={'hoch'}
                  >
                    <SnowAnimator snowflakeCount={220} />
                  </SnowAnimationContainer>
                  <KugelHochSVG />
                </div>
              </div>

              <div className='list hoch'>
                <ul>
                  <li dangerouslySetInnerHTML={{__html: this.props.languageContent.hoheLagen.metrics[0]}}></li>
                  <li dangerouslySetInnerHTML={{__html: this.props.languageContent.hoheLagen.metrics[1]}}></li>
                  <li dangerouslySetInnerHTML={{__html: this.props.languageContent.hoheLagen.metrics[2]}}></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </TextWidth>
    )
  }
}
